<div class="solictud-recibida">
  <div class="left">
    <!--<img src="./assets/img/exito-beneficio-covid19.png" />-->
    <img src="./assets/img/hombre-celular.png" alt="Suscripción beneficio covid19 satifactoria" />
  </div>
  <div class="right">
    <h2>
      Hemos recibido su<br />
      solicitud exitosamente.
    </h2>
    <h3>
      En un plazo de 5 días hábiles <br />
      recibirá la resolución de su caso.
    </h3>
    <p>
      Si tiene dudas o consultas llámanos<br />
       al 600 337 8000, de lunes a viernes<br />
       de 9:00 a 19:00 horas. 
    </p>
    <input type="button" value="FINALIZAR" class="btn btn-finalizar" [routerLink]="['/home']">
  </div>
</div>